export default defineAppConfig({
  ui: {
    container: {
      base: 'px-0 sm:px-0 lg:px-0 max-xl:px-0',
    },
    badge: {
      defaultVariants: {
        variant: 'outline',
      },
      variants: {
        variant: {
          ghost: 'border-0 bg-transparent text-neutral-default',
          default:
            'border border-neutral-border-default rounded-[999px]! text-neutral-default',
          outline:
            'border-neutral-border-default! ring-neutral-border-default! text-neutral-default! rounded-[999px]! bg-white',
        },
      },
    },
    card: {
      slots: {
        header: 'border-0 pb-0',
      },
    },
    button: {
      slots: {
        base: 'justify-center text-center',
      },
      variants: {
        size: {
          xl: 'h-12!',
        },
        color: {
          brand: '',
        },
      },
      compoundVariants: [
        {
          color: 'white' as const,
          variant: 'outline' as const,
          class:
            'border-white hover:bg-white bg-white text-button-secondary-foreground! hover:text-black border-solid',
        },
        {
          variant: 'outline',
          color: 'brand',
          class:
            'text-white bg-transparent border-white border hover:border-white-300 hover:text-white-300 hover:*:text-white-300',
        },
        {
          size: 'md' as const,
          class: {
            leadingIcon: 'size-4',
            trailingIcon: 'size-4',
            base: 'py-2.25 px-2.75',
          },
        },
      ],
    },

    modal: {
      slots: {
        header: 'border-transparent pb-0',
        title: 'leading-9.5 mb-2.5',
        overlay: 'bg-overlay!',
      },
    },

    input: {
      defaultVariants: {
        size: 'xl',
      },
      variants: {
        size: {
          xl: {
            base: 'h-10 px-3 typo-paragraph-sm-regular!',
            // leadingIcon: 'size-4.5',
          },
        },
      },
    },

    checkbox: {
      slots: {
        base: 'outline-0! ring-2 rounded-[4px]',
      },
    },

    // reset.css: button { line-height: 1.1 } ломает checked-индикатор (нужен !)
    radioGroup: {
      slots: {
        base: 'leading-none! shrink-0',
        indicator:
          "relative rounded-full after:content-[''] after:absolute after:left-1/2 after:top-1/2 after:-translate-x-1/2 after:-translate-y-1/2 after:rounded-full after:bg-default",
        item: 'items-center',
      },
    },

    textarea: {
      variants: {
        size: {
          xl: 'h-25! p-3!',
        },
      },
    },

    toast: {
      slots: {
        icon: 'text-accent-default!',
      },
    },

    progress: {
      slots: {
        // base: 'scale-x-[-1] bg-accent-default',
        // indicator: 'bg-accented! rounded-none rounded-l-full',
        base: 'scale-x-[-1]',
        indicator: 'bg-accented! rounded-none rounded-l-full',
      },
      variants: {
        color: {
          error: 'bg-error',
          info: 'bg-info',
          success: 'bg-success',
          warning: 'bg-warning',
          neutral: 'bg-neutral-300',
          primary: 'bg-primary',
          secondary: 'bg-secondary-300',
        },
      },
    },

    tooltip: {
      slots: {
        content: 'bg-tooltip text-sm text-white font-medium line ring-0',
        arrow: 'fill-tooltip stroke-transparent!',
      },
    },
  },
})
